import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'SegmentPipe',
  standalone: true
})
export class FullNameSegmentPipe implements PipeTransform {
  transform(value: string): string {
    // Handle null, undefined, or empty values
    if (!value || typeof value !== 'string') return ''

    if (value === 'salutations') return 'Title'

    const segment = value.split('_')
    if (segment.length === 2)
      return segment[0].charAt(0).toUpperCase() + segment[0].slice(1).toLowerCase() + ' ' + segment[1].charAt(0).toUpperCase() + segment[1].slice(1).toLowerCase()

    // Handle single word segments
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
  }
}
